import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CircleDot } from "lucide-react";

// Beast V1 Retainer Engine — compact Ops Home block.
// One tiny line per retainer Customer. Zero analytics cards.

const fmtHours = (v) => `${Number(v || 0).toFixed(2)}h`;
const fmtRange = (start, end) => {
  const opts = { month: "short", day: "numeric" };
  return `${new Date(start).toLocaleDateString("en-US", opts)} – ${new Date(end).toLocaleDateString("en-US", opts)}`;
};

export const RetainerStatusBlock = ({ onNavigate }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/admin/retainer/summary");
        if (alive) setRows(data?.customers || []);
      } catch {
        if (alive) setRows([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (loading) return null;
  if (!rows.length) return null;

  return (
    <div data-testid="retainer-status-block" className="bg-[#0F0F0F] border border-[#1F1F1F] rounded-lg p-4">
      <div className="ur-eyebrow mb-3">Retainer Status</div>
      <div className="space-y-2">
        {rows.map((r) => {
          const over = (r.overage_hours || 0) > 0;
          const clickable = !!onNavigate;
          return (
            <div
              key={r.customer_id}
              data-testid={`retainer-status-row-${r.customer_id}`}
              onClick={() => clickable && onNavigate?.("customers", { customerId: r.customer_id })}
              className={`flex items-center justify-between gap-3 py-2 border-b border-[#1A1A1A] last:border-b-0 ${
                clickable ? "cursor-pointer hover:bg-[#141414] rounded px-2" : ""
              }`}
            >
              <div className="min-w-0 flex-1">
                <div className="text-sm text-white truncate">{r.display_name}</div>
                {r.needs_setup ? (
                  <div className="text-xs text-[#A3A3A3]">Retainer Terms not configured</div>
                ) : (
                  <div className="text-xs text-[#A3A3A3]">{fmtRange(r.cycle_start, r.cycle_end)}</div>
                )}
              </div>
              {!r.needs_setup && (
                <div className="text-right shrink-0">
                  <div className="text-sm text-white" data-testid={`retainer-status-hours-${r.customer_id}`}>
                    {fmtHours(r.chargeable_hours)} / {fmtHours(r.included_hours)}
                  </div>
                  <div className={`text-xs ${over ? "text-[#FF6600]" : "text-[#A3A3A3]"} flex items-center gap-1 justify-end`}>
                    {over ? (
                      <>
                        <CircleDot className="w-3 h-3" /> {fmtHours(r.overage_hours)} overage
                      </>
                    ) : (
                      <>{fmtHours(r.remaining_hours)} remaining</>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RetainerStatusBlock;
